import type { AccordionData } from "@/design-system/Molecules/AccordionList/Accordion.types";
import React from "react";

const faqPairs: [string, React.ReactNode][] = [
  [
    "Why Choose Defy Medical?",
    <>
      Defy Medical is an expert Men's Health clinic. We take sexual health
      seriously, and we've put together a simple process to access treatment
      through DefyED. Our providers are experienced in treating ED along with
      low Testosterone, hair loss, weight gain, muscle loss, and more. In
      addition to our ED treatment, we offer a suite of health care services.{" "}
      <a
        href="https://www.defymedical.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#181a20] underline"
      >
        Learn more about us.
      </a>
    </>,
  ],
  [
    "How does ED treatment work at Defy Medical?",
    <>
      It's simple! fill out our online questionnaire to provide us with details
      about your health history. Then we'll give you recommendations on the best
      medications for you. Order your medication online and have it delivered
      directly to your door.
    </>,
  ],
  [
    "What does DefyED offer?",
    <>
      We offer access to common ED meds like Sildenafil (same ingredient as
      Viagra®). We also offer ED injections like Trimix for men seeking a
      faster and more powerful ED treatment.
    </>,
  ],
  [
    "How does ED treatment work at Defy Medical?",
    <>
      It's simple! fill out our online questionnaire to provide us with details
      about your health history. Then we'll give you recommendations on the best
      medications for you. Order your medication online and have it delivered
      directly to your door.
    </>,
  ],
  [
    "Does DefyED take insurance?",
    <>
      We don't take insurance. Instead, we offer transparent, affordable prices
      with no insurance-related surprises.
    </>,
  ],
  [
    "How does DefyED choose pharmacies for its pharmacy network?",
    <>
      We build our network by vetting pharmacies and ensuring that they meet
      high standards, follow USP and Good Manufacturing Practices, and utilize active ingredients.
    </>,
  ],
  [
    "How long does it take for a practitioner to review my information?",
    <>
      Our Care Team typically reviews health questionnaires within 24 business
      hours.
    </>,
  ],
  [
    "What is the shipping process for my medication?",
    <>
      Once you place an order, Defy Medical sends it to a pharmacy within our
      Pharmacy Network. The pharmacy then ships your medication directly to your
      door. You'll receive a tracking number when your order ships.
    </>,
  ],
  [
    "Does DefyED ship to my state?",
    <>
      DefyED's Pharmacy Network can deliver to every state except California,
      Mississippi, and Idaho. Our network cannot ship oral medications to
      Minnesota but can ship Trimix injections.
    </>,
  ],
  [
    "When will my order ship?",
    <>
      Orders ship out on weekdays. Orders placed after 5 PM on Friday will be
      processed and shipped the following week. You'll receive tracking
      information from the pharmacy when your order ships.
    </>,
  ],
  [
    "What is erectile dysfunction (ED)?",
    <>
      <p>
        ED is the inability to achieve and maintain an erection throughout
        sexual activity.
      </p>
      <br />
      <p>
        Men with ED may not be able to have an erection at all, or they may
        experience erections that fade too quickly. Premature ejaculation can
        also be a symptom of ED.
      </p>
    </>,
  ],
  [
    "What causes ED?",
    <>
      <p>
        Some medical conditions like hypertension, obesity, and heart disease
        can cause ED. Stress, genetic factors, and certain medications may also
        contribute to ED symptoms.
      </p>
      <br />

      <p>
        One common cause of ED is Testosterone deficiency. Other noticeable
        symptoms of low Testosterone levels include:
      </p>
      <br />
      <ul className="list-disc pl-8 mt-0 mb-4 space-y-1 text-gray-600">
        <li>Loss of libido</li>
        <li>Difficulty building muscle</li>
        <li>Fat gain</li>
        <li>Fatigue and insomnia</li>
        <li>Mood issues ED?</li>
      </ul>
    </>,
  ],
  [
    "What are treatments for ED?",
    <>
      <p>
        Vasodilators like Sildenafil and Tadalafil can improve blood flow to the
        penis for better and stronger erections. These are the most well-known
        ED treatments and are effective for many men.
      </p>
      <br />

      <p>
        Medications like Oxytocin can help improve connection during intimacy
        and potentially boost sex drive.
      </p>
      <br />
      <p>
        For severe ED, Trimix injection therapy is one of the strongest ED
        treatments. Trimix is typically considered when oral ED medications like
        Sildenafil fail.
      </p>
      <br />
      <p>
        Testosterone Replacement Therapy (TRT) is an ongoing treatment that
        replenishes Testosterone levels to address the root cause. TRT can ease
        ED and other symptoms long-term.*{" "}
        <a
          href="https://www.defymedical.com/services/trt/?_gl=1*pwglyp*_up*MQ..*_ga*NzcyNDMwNjU1LjE3NTMxMDU0ODI.*_ga_XWPYJFFXE5*czE3NTMxMDU0ODEkbzEkZzAkdDE3NTMxMDU0ODEkajYwJGwwJGgw"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#181a20] underline"
        >
          Learn more about TRT to treat ED
        </a>
      </p>
      <br />
      <p className={`text-sm`}>
        *Testosterone Replacement Therapy requires comprehensive lab work to
        diagnose a deficiency, a consultation with a provider, and regular
        follow-ups. If you’re experiencing ED along with other low T symptoms,
        we recommend a more thorough evaluation that checks your hormone levels,
        and a TRT protocol if appropriate.
      </p>
    </>,
  ],
  [
    "Can I combine ED medications?",
    <>
      <p>
        We do not recommend combining ED medications, especially ED injections
        and traditional oral medications. This can lead to a potential medical
        emergency called priapism, or an erection lasting longer than 4 hours.
        Instead of combining therapies, work with Defy Medical to find the right
        medication and dosage for the results you want.
      </p>
    </>,
  ],
  [
    "How long does it take to see results from ED medications?",
    <>
      <p>
        Result times depend on the medication and the patient's response. In
        general, oral medications typically take around 30 minutes to an hour,
        while ED injections trigger a response in 5-15 minutes on average.
      </p>
    </>,
  ],
];
export const aboutUsFaqData: AccordionData[] = faqPairs.map(
  ([question, answer]) => ({
    question,
    answer
  })
);